<template>
    <div class="app-seleccionarProveedor">
      <form class="app-seleccionarProveedor-form">
        <img class="app-seleccionarProveedor-logo" src="../assets/img/logo_white.png" alt="Eurocaja Rural"/>
        <h4 class="app-seleccionarProveedor-title">Portal de Proveedores de Confirming</h4>
        <div class="form-group">
        <div class="mensajeErrorReducido" v-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
        </div>
        </div>
        <p class="app-seleccionarProveedor-perlog">Hola, {{ usuario }}</p>
        <p class="app-seleccionarProveedor-perlog">Selecciona el proveedor con el que quieres operar</p>
        <!--<div class="form-field-wrapper">
          <div class="form-field-flex">
            <div class="form-field-infix">
              <input type="text" id="buscador" v-on:keyup="buscar" v-model="textoBuscador" class="inputComponent">
              <span class="form-field-label-wrapper">
                
              </span>
            </div>
            <div class="form-field-suffix">
              <span class="material-icons app-seleccionarProveedor-search-icon">search</span>
            </div>
          </div>
        </div>-->
        <div class="form-contSelProveedor">
          <div :class = "listaProveedores.length>4?'app-seleccionarProveedor-list':'app-seleccionarProveedor-low-list'">
            <button type="button" v-for="persona in listaProveedores" v-bind:key="persona.id" class="btnPrimary app-seleccionarProveedor-button" @click="onSeleccionarProveedor(persona.id)">
              <span>{{persona.contractName}}</span>
            </button>
          </div>
        </div>
      </form>
  </div>
</template>

<script>
export default {
    name : 'QueryProvidersComponent',
    data(){
      return{
        //textoBuscador:null,
        confirmacion:null,
        mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
        usuario: null,
        listaProveedores:[]
      }
    },
    created: function(){ //aqui iria una llamada a funcion consultaPrevia y metemos la lista de proveedores de salida en una cookie
      var ventana=this;
      const baseURI = '/api-users/users/me';
      let loader = this.$loading.show();
      this.$http.get(baseURI)
      .then((result) => {
        this.listaProveedores=result.data.data.profiles;
        this.usuario=result.data.data.userName;
        this.$cookies.set('userName', result.data.data.userName);
        this.$cookies.set('userNumber',result.data.data.userNumber);
        this.$cookies.set('providersList',JSON.stringify(this.listaProveedores));
      })
      .catch(function (error) {
        if(error.response){
                if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                  ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                }else{ //si no, por defecto
                  ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                }
              }else{ //si no, por defecto
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
              }
              ventana.confirmacion='KO';
              window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
      })
      .then(function () {
        loader.hide();
      });
    },
    methods : {
    onSeleccionarProveedor(id){
        var proveedor=this.listaProveedores.find(x => x.id === id);
        this.$cookies.set('providerSelected',proveedor); //guardamos el proveedor seleccionado en una cookie, como contextualizarlo
        this.$http.defaults.headers.common['X-USER-PROFILE-ID'] = id;
        let loader = this.$loading.show();
        setTimeout(() => {
          this.$router.push({ name:'home', params: { usuario: this.usuario}});
          loader.hide();
        },700);
    },
   /* buscar(){
      var textoBuscador=this.textoBuscador;
      document.getElementsByClassName("app-seleccionarProveedor-button").forEach(function(boton){
        if(boton.innerText.toLowerCase().indexOf(textoBuscador.toLowerCase())>=0){
          boton.style.display="";
        }else{
          boton.style.display="none";
        }
      });
    }*/
  }
}
</script>